// @flow

import { backendAxios } from './axios-config';
import isEmpty from 'lodash/isEmpty';
import CustomError from '../utils/error';

const { REACT_APP_WB_BACKEND_URL } = process.env;

const getServiceForms = () => {
  if (isEmpty(REACT_APP_WB_BACKEND_URL)) throw new CustomError('Empty URL');

  return backendAxios.get('/service-forms');
};

// const getServiceForms = () => ({
//   data: [
//     {
//       documentName: 'Latest info',
//       documentType: 'pdf',
//       dateAdded: 'June 23, 2020',
//       id: 1,
//     },
//     {
//       documentName: 'Latest info',
//       documentType: 'pdf',
//       dateAdded: 'June 23, 2020',
//       id: 2,
//     },
//     {
//       documentName: 'Latest info',
//       documentType: 'pdf',
//       dateAdded: 'June 23, 2020',
//       id: 3,
//     },
//   ],
// });

export default getServiceForms;
